export const exhaustiveCheck = (input: never) => {
  const exhaustiveCheck: never = input
  throw new Error(`Unhandled case: ${JSON.stringify(exhaustiveCheck)}`)
}